import { Injectable, inject } from "@angular/core";
import {Store} from "@ngrx/store";
import {ActivatedRouteSnapshot, Router, UrlTree} from "@angular/router";
import {Observable, withLatestFrom} from 'rxjs';
import {map} from "rxjs/operators";
import {SharedLoginSelectors} from "@shared/components/login/store/shared-login.selector-type";

@Injectable({
  providedIn: 'root'
})
export class TechAppLoginGuard {
  private store = inject(Store);
  private router = inject(Router);


  canActivate(state: ActivatedRouteSnapshot):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.store.select(SharedLoginSelectors.selectToken).pipe(
      withLatestFrom(this.store.select(SharedLoginSelectors.selectTenant)),
      map(([token, tenant]) => {
        if (!!token?.refreshToken && !!tenant) {
          if (token?.info?.isGuest) {
            return this.router.createUrlTree(['not-allowed']);
          } else {
            return true;
          }
        } else {
          return this.router.createUrlTree(['tech/login'], {
            queryParams: {
              redirect: `${ window.location.href }`
            }
          });
        }
      })
    )
  }

}
